import { CardWidget } from '@/components/ui/card-widget';
import { ActivitiesList } from './ActivitiesList';

export function ActivityContainer() {
  return (
    <>
      <CardWidget>
        <h3 className="text-lg font-semibold mb-4">Recent Activities</h3>
        <ActivitiesList 
          className="max-h-96 overflow-y-auto"
        />
      </CardWidget>
    </>
  );
}
